module.exports = __webpack_public_path__ + "img/arrow-down.22a53aaf.svg";